import config from 'config';

import { FC } from 'react';
// i18next
import { useTranslation } from 'react-i18next';
// Layouts
import { Dialog, DialogTitle, DialogContent, DialogActions } from 'layouts/Dialog';
// Components
import { Button } from 'components/Buttons';
import Copy from 'components/Copy';

type Props = {
  open: boolean;
  onClose: () => void;
  quizNameSlug: string;
}

const ShareQuizLinkDialog:FC<Props> = ({ open, onClose, quizNameSlug }) => {
  const { t } = useTranslation();

  const url = `${config.shareURL}/quiz/${quizNameSlug}`;

  return (
    <Dialog size="sm" open={open} onClose={onClose}>
      <DialogTitle title={t('dialogs.shareQuizLink.title')} onClose={onClose} />
      <DialogContent>
        <span className="block text-gray-400 text-sm mb-2">{t('dialogs.shareQuizLink.hint')}</span>
        <div className="flex items-center gap-2">
          <a
            rel="noreferrer" target="_blank"
            className="text-sm text-primary hover:underline break-all"
            href={url}
          >{url}</a>
          <Copy text={url} />
        </div>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{t('buttons.close')}</Button>
      </DialogActions>
    </Dialog>
  )
}

export default ShareQuizLinkDialog;
